"use client";

import React, { useEffect } from "react";

const WufooForm = ({ formHash, userName, id }: { formHash: string; userName: string; id?: string }) => {
	useEffect(() => {
		// Erstelle das Script-Element
		const script = document.createElement("script");
		script.type = "text/javascript";
		script.async = true;

		// Optionen aus dem Snippet
		script.src = ("https:" === document.location.protocol ? "https://" : "http://") + "secure.wufoo.com/scripts/embed/form.js";

		script.onload = () => {
			try {
				const options = {
					userName: userName,
					formHash: formHash,
					autoResize: true,
					height: "600",
					async: true,
					host: "wufoo.com",
					header: "show",
					ssl: true,
				};

				if (id) {
					const holder = document.getElementById(id);
					const holderElement = document.createElement("div");
					holderElement.id = "wufoo-" + formHash;

					if (!holder) {
						return null;
					}

					holder?.appendChild(holderElement);
				}

				const wufooForm = new (window as any).WufooForm();
				wufooForm.initialize(options);
				wufooForm.display();
			} catch (error) {
				console.error("Error initializing Wufoo form:", error);
			}
		};

		// Füge das Script der Seite hinzu
		document.body.appendChild(script);

		// Entferne das Script, wenn die Komponente entladen wird
		return () => {
			document.body.removeChild(script);
		};
	}, []);

	if (id) {
		return null;
	}

	return (
		<div>
			{/* Platzhalter für das Wufoo-Formular */}
			<div id={`wufoo-${formHash}`} style={{ backgroundColor: "white" }}>
				Fill out my <a href={`https://futurehain.wufoo.com/forms/${formHash}`}>online form</a>.
			</div>
		</div>
	);
};

export default WufooForm;
